import React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import InputNumber from "../../../../../shared/components/inputs/InputNumber/InputNumber";
import InputText from "../../../../../shared/components/inputs/InputText/InputText";

function ExpenseConfigStep({ logic }) {
  return (
    <div className="enhanced-import-step expense-config-step">
      <div className="expense-config-header">
        <h3>Configuração de Despesa</h3>
        <p>
          Configure opcionalmente uma despesa financeira para este lote de
          produtos.
        </p>
      </div>

      <div className="expense-config-toggle">
        <FormControlLabel
          control={
            <Checkbox
              checked={logic.adicionarComoDespesa}
              onChange={(e) => logic.setAdicionarComoDespesa(e.target.checked)}
              color="primary"
            />
          }
          label="Adicionar custo como despesa no sistema financeiro"
        />
      </div>

      {logic.adicionarComoDespesa && (
        <div className="expense-config-form">
          <div className="expense-config-row">
            <InputText
              className=""
              label="Descrição da Despesa *"
              initialValue={logic.descricao || "Compra de produtos para stock"}
              handleChange={logic.handleDescricaoChange}
            />

            <InputNumber
              className=""
              label="Valor Total *"
              initialValue={logic.custoTotal}
              handleChange={logic.handleCustoTotalChange}
              min={0}
            />
          </div>

          <div className="expense-config-row">
            <div className="expense-config-row">
              <div className="expense-config-select-container">
                <label>Fornecedor</label>
                <select
                  value={logic.fornecedorDespesa || ""}
                  onChange={(e) => logic.setFornecedorDespesa(e.target.value)}
                  className="expense-config-select"
                >
                  <option value="">Nenhum fornecedor</option>
                  {logic.fornecedoresList.map((fornecedor) => (
                    <option key={fornecedor.id} value={fornecedor.id}>
                      {fornecedor.nome}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="expense-config-select-container">
              <label>Categoria de Despesa</label>
              <select
                value={logic.categoria}
                onChange={(e) => logic.setCategoria(e.target.value)}
                className="expense-config-select"
              >
                {logic.categoriasFinanceiro.map((cat) => (
                  <option key={cat.id} value={cat.id}>
                    {cat.value}
                  </option>
                ))}
              </select>
            </div>

            <div className="expense-config-select-container">
              <label>Caixa</label>
              <select
                value={logic.caixa}
                onChange={(e) => logic.setCaixa(e.target.value)}
                className="expense-config-select"
              >
                {logic.caixas.map((cai) => (
                  <option key={cai.id} value={cai.id}>
                    {cai.value}
                  </option>
                ))}
              </select>
            </div>

            <div className="expense-config-select-container">
              <label>Forma de Pagamento</label>
              <select
                value={logic.metodoPagamento}
                onChange={(e) =>
                  logic.handleMethodPaymentChange(e.target.value)
                }
                className="expense-config-select"
              >
                {logic.FORMAS_PAGAMENTO.map((metodo) => (
                  <option key={metodo} value={metodo}>
                    {metodo}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="expense-config-paid-container">
            <FormControlLabel
              control={
                <Checkbox
                  checked={logic.despesaPaga}
                  onChange={(e) => logic.setDespesaPaga(e.target.checked)}
                  color="primary"
                />
              }
              label="Despesa já está paga"
            />
          </div>
        </div>
      )}

      <div className="expense-config-summary">
        <h4>Resumo dos Produtos</h4>
        <ul className="expense-config-summary-list">
          <li>
            Total de itens: <strong>{logic.processedData.length}</strong>
          </li>
          <li>
            Valor total: <strong>{logic.custoTotal.toFixed(2)}CVE</strong>
            {logic.processedData.some((item) => !item.precoCompra) && (
              <span className="expense-config-summary-warning">
                (alguns produtos não têm preço definido)
              </span>
            )}
          </li>
          <li>
            Novos produtos:{" "}
            <strong>
              {logic.processedData.filter(
                (item) =>
                  !logic.stock?.stock.some(
                    (st) =>
                      st.produto.nome.toLowerCase() === item.nome.toLowerCase()
                  )
              ).length || 0}
            </strong>
          </li>
          <li>
            Produtos existentes atualizados:{" "}
            <strong>
              {logic.processedData.filter((item) =>
                logic.stock?.stock.some(
                  (st) =>
                    st.produto.nome.toLowerCase() === item.nome.toLowerCase()
                )
              ).length || 0}
            </strong>
          </li>
        </ul>
      </div>

      {logic.processedData &&
        logic.processedData.length > 0 &&
        logic.processedData.some((item) => item.precoCompra > 0) &&
        !logic.adicionarComoDespesa && (
          <div className="expense-config-recommendation">
            <p>
              <strong>Recomendação:</strong> Foram detectados preços nos
              produtos importados. Considere registrar uma despesa para melhor
              controle financeiro.
            </p>
          </div>
        )}
    </div>
  );
}

export default ExpenseConfigStep;
